import { MeetingListItem } from '@all-manager/design-system-v2';
import { DisplayedMeeting } from '../../types';
import MeetingMenuAction from '../MeetingMenuAction/MeetingMenuAction';
import { MeetingDescriptionModal } from '../modals/MeetingDescriptionModal';
import { useMeetingRow } from './useMeetingRow';

type Props = {
  meeting: DisplayedMeeting;
  upcoming?: boolean;
};

export default function MeetingRow(props: Props) {
  const hook = useMeetingRow(props);

  return (
    <>
      <MeetingListItem
        title={props.meeting.title}
        date={hook.date}
        upcoming={props.upcoming}
        badge={hook.badge}
        reportLabel={hook.reportUrl ? 'Compte rendu' : undefined}
        href={hook.reportUrl}
        onClick={hook.handleOpen}
        action={hook.isAdmin ? <MeetingMenuAction meeting={props.meeting} name={hook.name} /> : undefined}
      />

      {hook.isDescriptionModalOpen ? (
        <MeetingDescriptionModal meeting={props.meeting} onClose={hook.handleCloseDescriptionModal} />
      ) : null}
    </>
  );
}
